<template>
  <div class="offer-map-section tw-relative">
    <div
      ref="container"
      class="offer-map-section__map"
      data-test="map"
    />

    <offer-travel
      v-if="offer && offer.travel && offer.travel.distance && offer.travel.duration"
      :distance="offer.travel.distance"
      :duration="offer.travel.duration"
      class="tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-m-auto tw-mb-3"
    />
  </div>
</template>

<script>
  import { defineComponent, onBeforeUnmount, onMounted, ref, toRefs, watch } from '@vue/composition-api'

  import OfferTravel from './_subs/OfferTravel/index.vue'

  import { addZoomControl } from '@/services/GoogleMaps'
  import useMap from '@/composables/useMap'

  /**
   * @module component - OfferMapSection
   */
  export default defineComponent({
    name: 'OfferMapSection',
    components: {
      OfferTravel
    },
    props: {
      offer: {
        type: Object,
        required: true
      }
    },
    setup (props) {
      const { offer } = toRefs(props)
      const { createMap, drawOffer, clear, retrieveItinerary } = useMap()

      const container = ref(null)

      /**
       * @function showOffer
       */
      const showOffer = () => {
        drawOffer(offer.value)
        retrieveItinerary(offer.value)
      }

      onMounted(async () => {
        const map = await createMap(container.value, { scrollwheel: false })
        if (!map) return

        addZoomControl(map)
        showOffer()
      })

      watch(offer, showOffer)

      onBeforeUnmount(clear)

      return {
        container
      }
    }
  })
</script>

<style lang="scss" scoped>
  .offer-map-section {
    &__map {
      width: 100%;
      height: 300px;
      z-index: 0;
    }
  }

  .offer-travel {
    max-width: 280px;
  }
</style>
